import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';

import { setModoTela, initForm } from './motoristaDiariaActions';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import labelAndInputMask from '../common/form/labelAndInputMask';

class MotoristaDiariaForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='data_diaria'
								component={labelAndInputMask}
								label='Data' placeholder='Informe a data'
								cols='12 6 4 3'
								mask='99/99/9999'
								readOnly={this.props.formularioValues.id ? null : 'readOnly'} />

							<Field
								name='id_motorista'
								component={Select}
								options={this.props.listaMotorista.filter(motorista => this.props.formularioValues.id || !this.props.lista.filter(item => item.id_motorista == motorista.id).length)}
								label='Motorista'
								cols='12 12 12 12'
								placeholder='Selecione o motorista'
								readOnly={!this.props.formularioValues.id ? null : 'readOnly'} />
							
							<Field
								name='id_veiculo'
								component={Select}
								options={this.props.listaVeiculo}
								label='Veículo'
								cols='12 12 12 12'
								placeholder='Selecione o veículo'
								readOnly={readOnly} />

							<Field
								name='id_tipo'
								component={Select}
								options={this.props.listaTipo}
								label='Tipo'
								cols='12 12 12 12'
								placeholder='Selecione o tipo'
								readOnly={readOnly} />

							<Field
								name='cidade'
								component={LabelAndInput}
								label='Cidade'
								cols='12 12 12 12'
								placeholder='Informe'
								readOnly={readOnly} />

							<Field
								name='observacao'
								component={LabelAndInput}
								label='Observação'
								cols='12 12 12 12'
								placeholder='Informe'
								readOnly={readOnly} />
								
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

MotoristaDiariaForm = reduxForm({form: 'motoristaDiariaForm', destroyOnUnmount: false})(MotoristaDiariaForm);
const mapStateToProps = state => ({
	sessao: state.auth.motoristaDiaria,
	formularioValues: getFormValues('motoristaDiariaForm')(state),
	registro: state.motoristaDiaria.registro,
	lista: state.motoristaDiaria.lista,
	listaTipo: state.motoristaDiaria.listaTipo,
	listaMotorista: state.motoristaDiaria.listaMotorista,
	listaVeiculo: state.motoristaDiaria.listaVeiculo
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MotoristaDiariaForm);
